export const purchaseUrls = {
  base: 'https://www.compradigitalya.com/cart/43078781894727:1',
  premium: 'https://www.compradigitalya.com/cart/43078782255175:1',
}

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/p4fNCu2b5stX8fVu9ZBhWF/ChatGPT_Image_10_ago_2026,_07_41_20_p.m..png'

export const testimonials = [
  {
    initials: 'CV',
    name: 'Carolina V.',
    place: 'Buenos Aires, Argentina · 41 años · Administrativa',
    text: 'Tenía dolor lumbar hacía tres años. Probé de todo: médicos, masajes, pastillas. Con el Tomo 3 entendí por primera vez qué estaba pasando en mi cuerpo y cómo solucionarlo. En un mes el dolor bajó más del 70% y ya no me levanto rígida por las mañanas.',
  },
  {
    initials: 'RM',
    name: 'Rodrigo M.',
    place: 'Rosario, Argentina · 36 años · Programador',
    text: 'Paso 9 horas por día sentado y la espalda me mataba al final del día. Con las rutinas del Bono 2 empecé a hacer pausas activas en el trabajo. En dos semanas dejé de tomar ibuprofeno y hoy termino la jornada sin esa puntada en la cervical.',
  },
  {
    initials: 'GP',
    name: 'Graciela P.',
    place: 'Córdoba, Argentina · 53 años · Docente',
    text: 'Siempre creí que el dolor de espalda era “normal” a los 50. El Tomo 1 me demostró que no. Empecé con las secuencias de 10 minutos y seguí la progresión sin saltearme nada. Hoy tengo más movilidad que a los 40 y subo escaleras sin quejarme.',
  },
]

export const tomos = [
  {
    icon: '📘',
    name: 'Movilidad de Espalda y Columna',
    period: 'Programa Integral de Salud Vertebral',
    content: [
      'Movilidad completa de cuello, espalda alta, espalda baja y cadera.',
      'Secuencias de 5, 10 y 15 minutos listas para usar cualquier día.',
      'Más de 24 ejercicios con instrucciones claras paso a paso.',
      'Criterios simples para saber cuándo aumentar el rango de movimiento.',
      'Rutina de despertar y rutina de descarga nocturna.',
    ],
  },
  {
    icon: '📗',
    name: 'Fortalecimiento de Espalda y Core',
    period: 'Programa Integral de Salud Vertebral',
    content: [
      'Activación del core profundo, glúteos y estabilizadores de columna.',
      'Rutinas progresivas de principiante a intermedio.',
      'Tabla de progresión de 12 semanas incluida.',
      'Cómo respirar y presurizar el abdomen en cada ejercicio.',
      'Errores más comunes que anulan el trabajo del core.',
    ],
  },
  {
    icon: '📙',
    name: 'Espalda Baja y Zona Lumbar',
    period: 'Programa Integral de Salud Vertebral',
    content: [
      'Evaluación inicial para saber desde dónde empezás.',
      'Sistema de Semáforo para entrenar de forma segura con molestia.',
      'Protocolo específico para hernia, contractura y rigidez crónica.',
      'Qué hacer en un episodio agudo de lumbalgia, día por día.',
      'Bisagra de cadera: el patrón que protege tu columna al levantar peso.',
    ],
  },
  {
    icon: '📕',
    name: 'Postura, Estabilidad y Control',
    period: 'Programa Integral de Salud Vertebral',
    content: [
      'Evaluación postural práctica que podés hacer solo en casa.',
      'Higiene postural para el escritorio, el celular y el manejo.',
      'Rutinas para trabajadores sedentarios y personas que están de pie muchas horas.',
      'Control escapular y cervical para el dolor de espalda alta.',
      'Checklist de puesto de trabajo para corregir tu día completo.',
    ],
  },
  {
    icon: '📓',
    name: 'Entrenamiento Completo: Casa y Gimnasio',
    period: 'Programa Integral de Salud Vertebral',
    content: [
      'Rutinas completas de 40 a 60 minutos para casa y gimnasio.',
      'Programa anual de 12 meses con progresión trimestral.',
      'Evaluación anual con registro de progreso.',
      'Alternativas de cada ejercicio según el equipamiento disponible.',
      'Cómo combinar movilidad, fuerza y postura en una misma semana.',
    ],
  },
]

export const bonuses = [
  [
    '01',
    '🏃',
    'Rutinas Express',
    'Rutinas de 5, 10, 15, 20 y 30 minutos para cuando no tenés tiempo. Siempre tenés una opción para moverte, incluso los días más cargados. Ideal para sostener el hábito sin excusas.',
    '$12.000',
  ],
  [
    '02',
    '💺',
    'Espalda para Personas Sedentarias',
    'Pausas activas, rutinas post-jornada y hábitos diarios para personas que trabajan sentadas, estudian o usan mucho el celular. Compensá el daño postural acumulado en pocos minutos por día.',
    '$12.000',
  ],
  [
    '03',
    '🏠',
    'Entrenamiento en Casa',
    'Rutinas completas con peso corporal, silla, pared, banda y mancuernas. Sin gimnasio, sin excusas. Todo pensado para hacerlo en un metro cuadrado de living.',
    '$14.000',
  ],
  [
    '04',
    '🏋️',
    'Entrenamiento en Gimnasio',
    'Cómo usar poleas, máquinas y peso libre para entrenar la espalda con criterio. Alternativas para cuando una máquina no está disponible y progresión de cargas sin arriesgar la columna.',
    '$14.000',
  ],
  [
    '05',
    '📅',
    'Plan Anual y Seguimiento',
    'Calendarios, checklists y fichas de seguimiento para saber exactamente qué hacer cada semana durante 12 meses. Nunca más improvisar ni abandonar a la tercera semana.',
    '$12.000',
  ],
] as const

export const faqs = [
  [
    '¿Sirve si nunca entrené o llevo mucho tiempo sin moverme?',
    'Sí. El sistema empieza desde cero. Cada ejercicio tiene instrucciones claras y criterios para saber cuándo avanzar. No necesitás experiencia previa ni equipamiento especial: los primeros tomos se hacen con peso corporal, una silla y una pared.',
  ],
  [
    '¿Cómo recibo el material?',
    'Inmediatamente después de confirmar el pago recibís un correo de compradigitalyaa@gmail.com con el enlace de descarga. Acceso en menos de 5 minutos y el material queda tuyo para siempre.',
  ],
  [
    '¿La garantía es real?',
    'Sí. Tenés 7 días para probarlo. Si no te sirve, escribís a compradigitalyaa@gmail.com y te devolvemos el dinero completo. Sin preguntas, sin formularios eternos.',
  ],
  [
    '¿Sirve si tengo una hernia o una lesión diagnosticada?',
    'El programa incluye adaptaciones específicas para hernia, contractura y rigidez crónica, además del Sistema de Semáforo para entrenar seguro cuando hay molestia. Si tenés una patología severa, consultá con tu médico antes de empezar.',
  ],
  [
    '¿Puedo imprimirlo?',
    'Sí. Todos los PDFs están optimizados para imprimir en A4, incluidas las fichas de seguimiento y los calendarios. Podés trabajar en papel o desde el celular.',
  ],
  [
    '¿Cuánto tiempo por día necesito?',
    'Con 10 a 15 minutos por día ya empezás a notar cambios. El Bono 1 incluye rutinas express de 5 a 30 minutos, y el Tomo 5 tiene sesiones completas de 40 a 60 minutos para los días que tengas más tiempo.',
  ],
  [
    '¿Necesito comprar equipamiento?',
    'No. Todo el programa se puede hacer con peso corporal, una silla, una pared y una toalla. Si tenés banda elástica, mancuernas o gimnasio, los Bonos 3 y 4 te muestran cómo aprovecharlos.',
  ],
  [
    '¿En cuánto tiempo voy a notar resultados?',
    'La mayoría nota menos rigidez y más movilidad en las primeras 2 semanas. Los cambios de fuerza y estabilidad aparecen entre la semana 4 y la 12, siguiendo la tabla de progresión del Tomo 2.',
  ],
  [
    '¿Sirve para personas mayores de 50 o 60 años?',
    'Sí. Cada ejercicio tiene versión simplificada y criterios de avance. Muchos de nuestros compradores tienen entre 45 y 65 años y empiezan por las secuencias de movilidad del Tomo 1.',
  ],
  [
    '¿Puedo pagar en cuotas y es seguro?',
    'Sí. El pago se procesa con Mercado Pago, podés usar tarjeta de crédito en cuotas, débito o transferencia. La compra es 100% segura y no guardamos ningún dato de tu tarjeta.',
  ],
] as const

export const recentPurchases = [
  ['Carolina V.', 'Buenos Aires', 'Combo Completo Espalda y Columna'],
  ['Rodrigo M.', 'Rosario', 'Combo + Mega Kit Espalda 365'],
  ['Graciela P.', 'Córdoba', 'Combo Completo Espalda y Columna'],
  ['Martín S.', 'Mendoza', 'Combo + Mega Kit Espalda 365'],
  ['Valeria L.', 'La Plata', 'Combo Completo Espalda y Columna'],
  ['Sergio D.', 'Mar del Plata', 'Combo + Mega Kit Espalda 365'],
  ['Andrea F.', 'Salta', 'Combo Completo Espalda y Columna'],
  ['Pablo N.', 'Neuquén', 'Combo Completo Espalda y Columna'],
  ['Marcela T.', 'San Miguel de Tucumán', 'Combo + Mega Kit Espalda 365'],
  ['Hernán B.', 'Bahía Blanca', 'Combo Completo Espalda y Columna'],
] as const
